export default __webpack_public_path__ + "static/web-0718a2d47ca4adef25abaefa4f6c6143.jpg";